import { render, staticRenderFns } from "./CreateSocial.vue?vue&type=template&id=5e84987a&scoped=true"
import script from "./CreateSocial.vue?vue&type=script&lang=js"
export * from "./CreateSocial.vue?vue&type=script&lang=js"
import style0 from "./CreateSocial.vue?vue&type=style&index=0&id=5e84987a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84987a",
  null
  
)

export default component.exports